+function($){
	interactiveKeyboardKeys = {}
	//param name - if set, keys will be stored in the global variable interactiveKeyboardKeys under this name
	$.fn.interactiveKeyboard = function(name){
		var t = $(this)
		t.keys = [] //collection of chosen keys

		//set the name property if available
		if (name){
			t.name = name
			interactiveKeyboardKeys[t.name] = []
		}
		else if(t.data('interactivekeyboardname')){
			t.name = t.data('interactivekeyboardname')
			interactiveKeyboardKeys[t.name] = []
		}

		//helper function which transforms special signs (e.g. ^ to SHIFT) and removes diacritics
		var signToKeyString = function(sign){
			if (typeof sign == "number") {
				sign = sign.toString();
			}
			return removeDiacritics(
				sign
					.replace('"', 'quote')
					.replace('^', 'shift')
					.replace('.', 'dot')
					.replace(',', 'comma')
					.replace('?', 'question')
					.replace('!', 'exclamation')
					.replace('(', 'bracketleft')
					.replace(')', 'bracketright')
					.replace('@', 'at')
					.replace('-', 'dash')
					.replace('/', 'slash')
					.replace(':', 'colon')
					.replace(';', 'semicolon')
					.toLowerCase())
		}

		//array storing functions which are called when the key collection changes
		var keysChangedFuncs = []

		//add an event handler to key changed event
		t.onKeysChanged = function(func){
			if (typeof func === 'function'){
				keysChangedFuncs.push(func)
			}
		}

		//helper func to fire key changed event
		var keysChangedEvent = function(){
			for (var i = 0; i < keysChangedFuncs.length; i++){
				keysChangedFuncs[i]()
			}
		}

		//set allowed letters based on data-allowedkeys
		t.allowedKeys = t.data('allowedkeys').split('')
		for (var i = 0; i < t.allowedKeys.length; i++){
			var key = signToKeyString(t.allowedKeys[i])
			t.allowedKeys[i] = key
			t.find('.key-' + key).addClass('enabled')
		}

		//add a key to the collection
		t.addKey = function(key){
			key = signToKeyString(key)
			if (key == 'bracket-right') return //to fix the bug adding two double brackets
			if (t.keys.indexOf(key) >= 0) return //the key is already in the collection
			if (t.allowedKeys.indexOf(key) < 0) return // the key is not allowed

			t.keys.push(key)
			if (t.name) interactiveKeyboardKeys[t.name].push(key)

			t.find('.key-' + key).addClass('chosen')
			keysChangedEvent()
		}

		//add multiple keys to the collection
		t.addKeys = function(keys){
			var keys = keys.split('')
			for (var i = 0; i < keys.length; i++){
				t.addKey(keys[i])
			}

			upperCaseLeters = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];
			for (var i = 0; i < upperCaseLeters.length; i++){
				if(keys.indexOf(upperCaseLeters[i]) > 0) { 
					t.addKey("shift")
					break;
				}
			}

		}

		//remove a key from the collection
		t.removeKey = function(key){
			key = signToKeyString(key)
			if (t.keys.indexOf(key) < 0) return //the key is not in the collection

			removeValueFromArray(key, t.keys)
			if(t.name) removeValueFromArray(key, interactiveKeyboardKeys[t.name])

			t.find('.key-' + key).removeClass('chosen')
			keysChangedEvent()
		}

        //remove multiple keys from the collection
        t.removeKeys = function(keys){ 
            var keys = keys.split('')
            for (var i = 0; i < keys.length; i++){
                t.removeKey(keys[i])
            }
        }

		//toggle keys in the collection on click
		$('.key.enabled', t).click(function(){
			var $key = $(this)
			if ($key.hasClass('chosen')) t.removeKey($key.data('key'))
			else t.addKey($key.data('key'))
		})

		//prepare default keys from data-defaultkeys
		if(t.data('defaultkeys')){
			t.addKeys(t.data('defaultkeys'))
		}

		//button add all available
		var addAllAvailableButtonClick = function(){
			$('.key.enabled:not(.chosen):not(.shift)', t).click()
			$('.key.enabled:not(.chosen).shift', t).first().click()
		}
		$('.add-all-available', t).click(addAllAvailableButtonClick)
		if(t.data('addavailablebutton')) $(t.data('addavailablebutton')).click(addAllAvailableButtonClick)

		//button remove all
		var removeAllButtonClick = function(){
			$('.key.enabled.chosen:not(.shift)', t).click()
			$('.key.enabled.chosen.shift', t).first().click()
		}
		$('.remove-all', t).click(removeAllButtonClick)
		if(t.data('removeallbutton')) $(t.data('removeallbutton')).click(removeAllButtonClick)

        //remove all keys from the collection
        t.removeAllKeys = removeAllButtonClick

		//function for counting selected vowels
		t.vowelsSelected = function(){
			var count = 0
			for (var i = 0; i < t.keys.length; i++){
				if('aeiouyáéíóúůýěAEIOUYÁÉÍÓÚŮÝ'.indexOf(addDiacritics(t.keys[i])) >= 0) count++
			}
			return count
		}

		t.areAllKeysSelected = function(){
			return $('.key.enabled.chosen').length >= $('.key.enabled').length
		}

		t.noKeysSelected = function(){
			return $('.key.enabled.chosen').length <= 0
		}

		return t
	}
}(jQuery)